import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ChatNoAudio from '../components/views/10_LandingPage/ChatNoAudio';
import Vonage from '../components/views/10_LandingPage/vonage';
import ShowResult from '../components/views/10_LandingPage/ShowResult';
import Admin from '../components/views/10_LandingPage/Admin';

import Page404 from "../components/views/ErrorPages/Page404";

const Routes = () => {

    return (
        <Switch>
            {/* null-->누구나 접근가능, true-->로그인한 사용자만 접근가능, false-->로그인 안한 사용자만 접근가능 */}
			<Route exact path="/" component={Vonage} />
			<Route exact path="/chat_no_audio" component={ChatNoAudio} />
            <Route exact path="/result" component={ShowResult} />
			<Route exact path="/admin" component={Admin} />
            <Route component={Page404} exact />

        </Switch>
    );
};

export default Routes;